<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header v-if="!vistaEmbebidaPaciente"/>
    <b-container fluid v-if="!vistaEmbebidaPaciente">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>AVPT (Plan Dental)</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>AVPT-01</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos"> Busqueda de Avance por Paciente</b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
              v-if="busqueda.opcion == 1"
              id="input-group-1"
              label-for="input-1"
          >
            <b-form-input
                class="ml-1 mr-1 mt-2"
                id="input-1"
                type="text"
                v-model="$v.busqueda.idPaciente.$model"
                :state="validateState('idPaciente')"
                placeholder="Ingresa un id de paciente"
            ></b-form-input>
          </b-form-group>

          <b-form-group v-else id="input-group-2" label-for="input-2">
            <b-form-input
                class="ml-1 mr-1 mt-2"
                id="input-2"
                type="text"
                v-model="$v.busqueda.nombrePaciente.$model"
                :state="validateState('nombrePaciente')"
                placeholder="Ingresa un nombre de paciente"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-left ml-1 col-sm-4" v-if="$localStorageService.can('Avpt_buscar')">
          <b-button
              :disabled="busqueda.opcion == null || loaderValPTI || loader || loader1"
              variant="primary"
              @click="buscarAVPT()">
            <span v-if="loaderValPTI || loader || loader1">
              <b-spinner small></b-spinner>
              Cargando...
            </span>

            <span v-else>
              Buscar
            </span>
          </b-button
          >
        </b-col>

        <b-col>
          <b-form-group class="text-left ml-1">
            <b-form-radio-group
                id="tipo"
                v-model="busqueda.opcion"
                name="opcion"
                @input="cambiarOpcion"
            >
              <b-form-radio :value="1">Buscar por id</b-form-radio>
              <b-form-radio :value="2">Buscar por nombre completo</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <div v-if="loadingPacientes">
        <b-spinner small></b-spinner>&nbsp;Buscando paciente...
      </div>
      <div v-if="loader || loader1">
        <b-spinner small></b-spinner>&nbsp;Buscando AVPT...
      </div>
      <div v-if="busqueda.opcion === 2 && blnSinDatosPaciente">
        No se encontraron pacientes
      </div>

      <b-row v-if="listaPacientes != null && mostrarListaPacientes">
        <div class="centrar">
          <b-col cols="10">
              <span
                  class="tablePatients"
                  v-if="!loading && listaPacientes.length > 0"
                  column="3"
              >
                <div class="mt-2 col-md-12"></div>
                <b-table
                    thead-tr-class="columnas"
                    :items="listaPacientes"
                    :fields="encabezados"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    :hover="true"
                    :small="true"
                    @row-clicked="setearPaciente"
                    class="parrafos"
                    responsive
                    fixed
                >
                  <template v-slot:cell(id)="row">
                    <span>{{ row.item.id }}</span>
                  </template>
                </b-table>
                <b-pagination
                    v-if="listaPacientes.length > 15"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="listaPacientes.length"
                    :per-page="registrosPorPagina"
                ></b-pagination>
              </span>
          </b-col>
        </div>
      </b-row>

      <div class="mt-3 col-md-12" style="background-color: white"></div>
    </b-container>
    <b-container fluid>
      <b-row v-if="sinPTIActivo">
        <b-alert show variant="warning" style="width: 100%; margin-bottom: 0px;">El paciente no cuenta con AVPT</b-alert>
      </b-row>
      <b-row v-if="!ocultarpti">
        <b-col cols="12">

          <b-popover target="popover-datosPTI" triggers="hover" placement="top">
            <!--            <template #title>Popover Title</template>-->
            <div v-if="ptiBusqueda !== undefined && ptiBusqueda !== null">
              <b-list-group>
                <b-list-group-item><strong>PTI: </strong>{{ptiBusqueda.idPti}}</b-list-group-item>
                <b-list-group-item><strong>Fecha de Presupuesto PTI: </strong>{{ptiBusqueda.fechaAceptacion | formatoFecha }}</b-list-group-item>
                <b-list-group-item><strong>Clínica: </strong>{{ptiBusqueda.clinicaNombre}}</b-list-group-item>
                <b-list-group-item><strong>EE: </strong>{{ptiBusqueda.nombreEmbajador}}</b-list-group-item>
                <b-list-group-item><strong>Total Sesiones: </strong>{{ptiBusqueda.totalSessiones}}</b-list-group-item>
              </b-list-group>
            </div>
          </b-popover>

          <b-tabs pills card v-model="tabIndex" v-if="!ocultarpti">


            <b-tab active lazy  >

              <template #title v-if="$localStorageService.can('Avpt_graf_modif')">
                <span id="popover-datosPTI">Gráfica diaria AvPTx - PTI de: {{
                    (paciente == null ? busqueda.idPaciente : paciente + '( ' + pacienteidencabezado + ')')
                  }} </span>
              </template>

              <b-row v-if="!loader && !loader1 && paciente != null && ocultarpti != true">
                <b-col cols="12">
                  <gantt ref="gantt2" v-if="tasks2.data.length > 0"
                         :tasks="tasks2" :editable="true"
                         :avanceGeneral="avanceGeneral"
                         @recorrerFechas="recorrerFechas"
                         @recorrerFechas1="recorrerFechas1"
                  ></gantt>
                  <div v-if="tasks2.data.length === 0">
                    <b-alert variant="warning" show>No se encontraron resultados</b-alert>
                  </div>
                </b-col>
              </b-row>

            </b-tab>


            <b-tab  lazy>

              <template #title v-if="$localStorageService.can('Avpt_graf_orig')">
                <span id="popover-datosPTI">Gráfica original  </span>
              </template>

              <b-row v-if="!loader && !loader1 && ocultarpti != true">
                <b-col cols="12">
                  <gantt ref="gantt1" v-if="tasks.data.length > 0"
                         :avanceGeneral="avanceGeneral"
                         :tasks="tasks" :editable="false"
                  ></gantt>
                  <div v-if="tasks.data.length === 0">
                    <b-alert variant="warning" show>No se encontraron resultados</b-alert>
                  </div>
                </b-col>
              </b-row>
            </b-tab>



          </b-tabs>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import Header from "../../components/Header";
import {required, numeric} from "vuelidate/lib/validators";
import Gantt from "../../components/Gantt.vue";
import Swal from "sweetalert2";

export default {
  name: "avptIndex",
  components: {
    Header,
    Gantt
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    vistaEmbebidaPaciente: false,
    sinPTIActivo: false,

    ptiBusqueda: null,
    avanceGeneral: 0,
    tabIndex: 1,
    pacienteidencabezado: null,
    ocultarpti: false,
    mostrarListaPacientes: false,
    loadingPacientes: false,
    blnSinDatosPaciente: false,
    listaPacientes: [],
    encabezados: [
      {
        key: "id",
        label: "Id",
      },
      {
        key: "nombre",
        label: "Nombre del Paciente",
      },
    ],
    registrosPorPagina: 15,
    paginaActual: 1,
    bandera: false,
    paciente: null,
    busqueda: {
      idPaciente: null,
      nombrePaciente: null,
      opcion: 1,
    },

    tasks: {
      data: [],
      links: [],
      collections: {
        sections: []
      },
      tabla: 1
    },

    tasks2: {
      data: [],
      links: [],
      collections: {
        sections: []
      },
      tabla: 2
    },

    loaderValPTI: false,
    loader: false,
    loader1: false,
    idUsuario: null,
    loaderEdit: false,
    loaderAcciones: false,
    loaderAccionesEdit: false,

    tasksEdit: [],
  }),

  validations() {
    if (this.busqueda.opcion == 1) {
      return {
        busqueda: {
          idPaciente: {required, numeric},
        },
      };
    } else {
      return {
        busqueda: {
          nombrePaciente: {required},
        },
      };
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.idPacienteAVPT !== undefined && this.idPacienteAVPT !== null) {
      this.vistaEmbebidaPaciente = true;
      this.busqueda.idPaciente = this.idPacienteAVPT;
      this.buscarAVPT();
    }

    this.ocultarpti = true;
    this.idUsuario = this.$localStorageService.getIdUsuario();
  },

  mounted() {
  },

  methods: {

    async setearPaciente(item) {
      this.sinPTIActivo = false;
      this.mostrarListaPacientes = false;
      this.busqueda.idPaciente = item.id;
      this.pacienteidencabezado = item.id;
      this.obtenerGraficaOriginal(this.busqueda.idPaciente);
    },
    llenarGraficasAVPT() {
      this.ocultarpti = true;
      if (this.busqueda.opcion == 1) {
        this.obtenerGraficaOriginal(this.busqueda.idPaciente);
      } else if (this.busqueda.nombrePaciente) {
        const inputTxt = this.busqueda.nombrePaciente
            .trim()
            .toLowerCase()
            .toUpperCase();

        this.listaPacientes = [];
        this.loadingPacientes = true;
        this.blnSinDatosPaciente = false;
        this.$http
            .get(
                this.$api +
                "avpt/obtenerDtaosPacientePorOpcionBusquedadAVPT?nombrePaciente=" +
                inputTxt +
                "&tipoBusqueda=" +
                2
            )
            .then((response) => {
              if (response.status === 200) {
                if (Array.isArray(response.data.data)) {
                  this.listaPacientes = response.data.data;
                  this.mostrarListaPacientes = true;
                }
              }
            })
            .catch((error) => {
              this.enviarMensajeSinAVPTOp1(error);
            })
            .finally(() => {
              this.loadingPacientes = false;
            });
      }
    },
    obtenerGraficaOriginal(idPaciente) {
      //this.$v.busqueda.$touch();
      if (this.$v.busqueda.$anyError) {
        return;
      }
      if (!this.$v.busqueda.$invalid) {
        this.loader = true;
        this.limpiarGraficas();
        this.$http
            .get(
                this.$api +
                "avpt/obtenerInformacionAVPTPorPTI?idPaciente=" +
                idPaciente
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                if (respuesta.data.data.lstDetalle === undefined || respuesta.data.data.lstDetalle === null
                    || respuesta.data.data.lstDetalle.length < 1) {
                  this.ocultarpti = true;
                  this.showAlertSindata();
                }
                this.avanceGeneral = respuesta.data.data.porcentajeAvance;
                let res = respuesta.data.data.lstDetalle.find((f) => f.paciente);
                this.paciente = res.paciente;
                let idAnterior = 0;

                let seq= 0;
                //let seqInx = null;
                respuesta.data.data.lstDetalle.forEach((it) => {
                  idAnterior = it.id;

                  let origenPTI = it.origenPTI === undefined || it.origenPTI === null || it.origenPTI === false ? "REP" : "";

                  let registroActivo = it.registroActivo ? "" : "<div style='position: absolute; left: 5px; top: -10px;'>x</div>";

                  if (it.pagado) {
                    it.pagado =
                        '<div style="position: relative; background: #5cb85c; width: 16px; height: 16px; border-radius: 50%; margin: 0 auto;">'+origenPTI+registroActivo+'</div>';
                  } else {
                    it.pagado =
                        '<div style="position: relative; background: #FFC300; width: 16px; height: 16px; border-radius: 50%; margin: 0 auto;">'+origenPTI+registroActivo+'</div>';
                  }

                  let fechaFechaRealizacion = null;
                  if (it.fechaRealizacionTratamiento != null) {
                    let fechaTemp = it.fechaRealizacionTratamiento.split("T", 1)
                  let fechaArray = fechaTemp[0].split("-",3)
                  let dia = fechaArray[2]
                  let mes = fechaArray[1]
                  let anio = fechaArray[0]
                  fechaFechaRealizacion = dia + "/" + mes + "/" + anio
                  }
                  

                  let datos = {
                    id: it.id,
                    text: it.tratamiento,
                    diente: it.diente === 0? it.nombreDiente: it.diente,
                    fase: it.fase,
                    etapa: it.etapa.substring(0, 3),
                    orc: it.especialidad,
                    duration: it.dias,
                    sumatoriaDias: it.dias,
                    progressNormal: it.progress,
                    progress: it.progress / 100,
                    backgroundColor: it.colorEstatusAVPT,
                    textColor: "black",
                    start_date: new Date(it.start),
                    fechaFin: new Date(it.fechaFin),
                    fechaPti: it.fechaPti,
                    parent: it.parentId,
                    pagado: it.pagado,
                    sesion: it.sesion,
                    tiempoEspera: it.tiempoEspera,
                    open: true,
                    idEtapa: it.idEtapa,
                    ordenClinico: it.ordenClinico,
                    orden: it.orden,
                    idTratamiento: it.idTratamiento,
                    type: "task",
                    editable: false,
                    fechaRealizacionTratamiento: fechaFechaRealizacion,
                    num: undefined
                  };

                  if (it.registroActivo) {

                    if (it.sesion === 1) {
                      seq++;
                    }

                    //seqInx = datos.idTratamiento+'-'+datos.diente;
                    datos.num = seq;
                  }


                  if (datos.parent === undefined || datos.parent === null) {
                    datos.sumatoriaDias = datos.sumatoriaDias + ([...respuesta.data.data.lstDetalle]
                        .filter(it1 => it1.parentId === datos.id)
                        .map(it1 => {
                          return it1.dias;
                        }).reduce(function (a, b) {
                          return a + b;
                        }, 0));
                  }

                  const linkTask = {id: datos.id, source: datos.parent, target: idAnterior, type: "0"};
                  const colorTask = {key: datos.id, backgroundColor: datos.backgroundColor, textColor: datos.textColor};

                  this.tasks.data.push(datos);
                  this.tasks.links.push(linkTask);
                  this.tasks.collections.sections.push(colorTask);

                });

                this.ocultarpti = false;
                ///this.obtenerGraficaModificada(idPaciente)


              } else {
                this.enviarMensajeSinAVPTOp2("Sin datos");
              }
            }).catch((error) => {
                this.enviarMensajeSinAVPTOp2(error);
            })
            .finally(() => {
              this.loader = false;
              this.obtenerGraficaModificada(idPaciente);
            });
      }
    },

    obtenerGraficaModificada(idPaciente) {
      this.loader1 = true;
      this.$http
          .get(
              this.$api + "avpt/obtener/arbol/modificado?idPaciente=" + idPaciente
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              let fechaActual = this.$moment();
              let idAnterior = 0;

              let seq= 0;
              respuesta.data.data.forEach((it) => {
                let fechaInicio = this.$moment(it.start);
                idAnterior = it.id;

                let origenPTI = it.origenPTI === undefined || it.origenPTI === null || it.origenPTI === false ? "REP" : "";

                let registroActivo = it.registroActivo ? "" : "<div style='position: absolute; left: 5px; top: -10px;'>x</div>";

                if (it.pagado) {
                  it.pagado =
                      '<div style="position: relative; background: #5cb85c; width: 16px; height: 16px; border-radius: 50%; margin: 0 auto;">'+origenPTI+registroActivo+'</div>';
                } else {
                  it.pagado =
                      '<div style="position: relative; background: #FFC300; width: 16px; height: 16px; border-radius: 50%; margin: 0 auto;">'+origenPTI+registroActivo+'</div>';
                }

                let fechaFechaRealizacion = null;
                if (it.fechaRealizacionTratamiento != null) {
                  let fechaTemp = it.fechaRealizacionTratamiento.split("T", 1)
                  let fechaArray = fechaTemp[0].split("-",3)
                  let dia = fechaArray[2]
                  let mes = fechaArray[1]
                  let anio = fechaArray[0]
                  fechaFechaRealizacion = dia + "/" + mes + "/" + anio
                }
                

                let datos = {
                  id: it.id,
                  text: it.tratamiento,
                  diente: it.diente === 0? it.nombreDiente: it.diente,
                  fase: it.fase,
                  etapa: it.etapa.substring(0, 3),
                  orc: it.especialidad,
                  duration: it.dias,
                  sumatoriaDias: it.dias,
                  progressNormal: it.progress,
                  progress: it.progress / 100,
                  backgroundColor: it.colorEstatusAVPT,
                  textColor: "black",
                  start_date: new Date(it.start),
                  fechaFin: new Date(it.fechaFin),
                  fechaPti: it.fechaPti,
                  parent: it.parentId,
                  pagado: it.pagado,
                  sesion: it.sesion,
                  tiempoEspera: it.tiempoEspera,
                  open: true,
                  idEtapa: it.idEtapa,
                  ordenClinico: it.ordenClinico,
                  orden: it.orden,
                  idTratamiento: it.idTratamiento,
                  type: "task",
                  editable: fechaInicio >= fechaActual && it.progress <= 0 && it.registroActivo,
                  fechaRealizacionTratamiento: fechaFechaRealizacion,
                  num: undefined
                };

                if (it.registroActivo) {

                  if (it.sesion === 1) {
                    seq++;
                  }

                  datos.num = seq;
                }

                if (datos.parent === undefined || datos.parent === null) {
                  datos.sumatoriaDias = datos.sumatoriaDias + [...respuesta.data.data].filter(it1 => it1.parentId === datos.id)
                      .map(it1 => {
                        return it1.dias;
                      }).reduce(function (a, b) {
                        return a + b;
                      }, 0);
                }

                const linkTask = {id: datos.id, source: datos.parent, target: idAnterior, type: "0"};
                const colorTask = {key: datos.id, backgroundColor: datos.backgroundColor, textColor: datos.textColor};

                this.tasks2.data.push(datos);
                this.tasks2.links.push(linkTask);
                this.tasks2.collections.sections.push(colorTask);

              });

              this.$bvToast.toast('Utilice (Rueda del raton) para scrollear de arriba a abajo.', {
                title: 'Atajo 1',
                noAutoHide: false,
                variant: 'primary',
                solid: true
              })

              this.$bvToast.toast('Utilice la (Ctrl + Rueda del raton) para scrollear de izquierda a derecha.', {
                title: 'Atajo 2',
                noAutoHide: false,
                variant: 'primary',
                solid: true
              })

              this.$bvToast.toast('Utilice la Esc para salir de pantalla completa.', {
                title: 'Atajo 3',
                noAutoHide: false,
                variant: 'primary',
                solid: true
              })

            }
          })
          .finally(() => {
            this.loader1 = false;
          });
    },
    showAlertSindata() {
      Swal.fire("Infomación", "No hay datos del PTI", "info");
    },
    cambiarOpcion() {
      this.busqueda.nombrePaciente = "";
      this.busqueda.idPaciente = null;
      this.listaPacientes = null;
      this.mostrarListaPacientes = false;
      this.blnSinDatosPaciente = false;
    },
    buscarAVPT() {
      this.sinPTIActivo = false;
      if (this.busqueda.opcion === 1) {
        this.pacienteidencabezado = this.busqueda.idPaciente;
        this.validarPTIAVPT();
      } else {
        this.llenarGraficasAVPT();
      }
    },
    async validarPTIAVPT() {
      this.sinPTIActivo = false;
      this.ptiBusqueda = null;
      this.loaderValPTI = true;
      if (this.busqueda.idPaciente != null) {
        const parametros = {idPaciente: this.busqueda.idPaciente}
        this.$http
            .post(
                this.$api +
                "avpt/validarPTIAVPT", parametros
            )
            .then((respuesta) => {
              if (respuesta.data.success) {
                if (respuesta.data.data !== undefined && respuesta.data.data !== null) {
                  this.ptiBusqueda = respuesta.data.data;
                  this.llenarGraficasAVPT();
                } else {
                  this.busqueda.idPaciente = null;
                  this.ocultarpti = true;
                  Swal.fire("Infomación", respuesta.data.message, "warning");
                  this.paciente = null;
                }
              }
            })
            .catch((error) => {
              this.enviarMensajeSinAVPTOp2(error);
             }).finally(() => this.loaderValPTI = false);
      } else {
        this.loaderValPTI = false;
      }

    },

    limpiarGraficas() {
      this.tasks = {
        data: [],
        links: [],
        collections: {
          sections: []
        },
        tabla: 1
      };
      this.tasks2 = {
        data: [],
        links: [],
        collections: {
          sections: []
        },
        tabla: 2
      };
    },

    validateState(name) {
      const {$dirty, $error} = this.$v.busqueda[name];
      return $dirty ? !$error : null;
    },

    recorrerFechas(id, parentId, tindex) {
      const tareaMover = this.tasks2.data[this.tasks2.data.findIndex(it=>Number(it.id) === Number(id))]
      const tareaDestino = this.tasks2.data[tindex];

      let diffDiasFechas = (tareaDestino.end_date - tareaMover.start_date) / (1000 * 3600 * 24);


      if (diffDiasFechas>0 || tareaDestino.tiempoEspera > 0) {
        diffDiasFechas += tareaDestino.tiempoEspera;

        tareaMover.start_date = new Date(tareaMover.start_date.getTime()).addDays(diffDiasFechas);
        tareaMover.end_date = new Date(tareaMover.end_date.getTime()).addDays(diffDiasFechas);
        tareaMover.fechaFin = tareaMover.end_date;
      }

      let ultimoEdit = tareaMover;
      for(let i= tindex; i<this.tasks2.data.length; i++) {
        const it = this.tasks2.data[i];

        if (it.editable && Number(it.id) !== Number(id) && ultimoEdit !== null) {
          const diffDiasFechaIt = (ultimoEdit.end_date - it.start_date) / (1000 * 3600 * 24);
          const tiempoMover = diffDiasFechaIt + ultimoEdit.tiempoEspera;


          it.start_date = new Date(it.start_date.getTime()).addDays(tiempoMover);
          it.end_date = new Date(it.end_date.getTime()).addDays(tiempoMover);
          it.fechaFin = it.end_date;

          ultimoEdit = it;
        }
      }
    },

    recorrerFechas1(id) {
      const dataFinal = [...this.tasks2.data].sort((a,b)=>{
        return a.$index-b.$index;
      });

      dataFinal.forEach(it=>it.orden=it.$index)


      const tareaMover = dataFinal[dataFinal.findIndex(it=>Number(it.id) === Number(id))]
      const tareaObjetivo = this.tasks2.data[tareaMover.$index];

      //RECORREMOS LOS DIAS DE DIFERENCIA CON RESPECTO AL OBJETIVO
      let diffDiasFechas = (tareaObjetivo.start_date - tareaMover.start_date) / (1000 * 3600 * 24);
      if (diffDiasFechas>0 || tareaObjetivo.tiempoEspera > 0) {
        tareaMover.start_date = new Date(tareaMover.start_date.getTime()).addDays(diffDiasFechas);
        tareaMover.end_date = new Date(tareaMover.end_date.getTime()).addDays(diffDiasFechas);
        tareaMover.fechaFin = tareaMover.end_date;
      }

      if (diffDiasFechas <= 0) { //cuando se mueve una tarea hacia atras
        let primeraVez = true;
        for (let i = tareaMover.$index + 1; i < dataFinal.length; i++) {
          const it = dataFinal[i];

          if (it.editable) {
            if (primeraVez) {
              it.start_date = new Date(tareaMover.end_date.getTime()).addDays(tareaMover.tiempoEspera);
            } else if (dataFinal[i - 1] !== undefined) {
              it.start_date = new Date(dataFinal[i - 1].end_date.getTime()).addDays(dataFinal[i - 1].tiempoEspera);
            }
            it.end_date = new Date(it.start_date.getTime()).addDays(it.duration);
            it.fechaFin = it.end_date;
            primeraVez = false;
          }
        }
      } else { //cuando se mueve una tarea hacia adelante
        const indiceBase = this.tasks2.data.findIndex(it=>Number(it.id) === Number(id))
        for (let i = indiceBase; i < dataFinal.length; i++) {
          const it = dataFinal[i];

          if (it.editable) {
            if (dataFinal[i - 1] !== undefined) {
              it.start_date = new Date(dataFinal[i - 1].end_date.getTime()).addDays(dataFinal[i - 1].tiempoEspera);
            }
            it.end_date = new Date(it.start_date.getTime()).addDays(it.duration);
            it.fechaFin = it.end_date;
          }
        }
      }

      this.tasks2.data = dataFinal;

      this.$refs.gantt2.actualizarDatos();
    },

    enviarMensajeSinAVPTOp1(error) {
      console.error(error);
      this.blnSinDatosPaciente = true;
      this.ocultarpti = true;
    },

    enviarMensajeSinAVPTOp2(error) {
      console.error(error);
      this.sinPTIActivo = true;
      this.ocultarpti = true;
    }
  },
  props: {
    idPacienteAVPT: Number
  }
};
</script>
